<div mat-dialog-content class="w-full bg-white !p-0 !m-0">
  <div class="modal-title">
    <h3 class="green decoration">Ubicación del activo</h3>
  </div>
  <div class="modal-inner">
    <p class="m-0"><strong>Activo:</strong> {{ data?.type }}<ng-container *ngIf="data?.model"> - {{ data?.model }}</ng-container><ng-container *ngIf="data?.cod_asset"> ({{ data?.cod_asset }})</ng-container></p>
    <p class="m-0 mb-3"><strong>Última vez usado:</strong> {{ data?.last_used_at || '---' }}</p>

    <div class="map-container" style="height: 350px; width: 100%;">
      <app-google-maps *ngIf="latLong" [latLong2]="latLong" [editable]="false"></app-google-maps>
      <p *ngIf="!latLong">Este activo todavía no reportó ubicación.</p>
    </div>
  </div>
</div>

<div mat-dialog-actions class="!m-0 w-full block">
  <div class="w-full flex justify-end actions_modal">
    <button mat-button type="button" (click)="dismiss()" class="btn btn-primary big">Cerrar</button>
  </div>
</div>
